import React from 'react';
import { Dropdown } from 'reactstrap';

export default class DropdownHover extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    toggle = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    onMouseEnter = () => {
        this.setState({ isOpen: true });
    }

    onMouseLeave = () => {
        this.setState({ isOpen: false });
    }

    render() {
        const { children } = this.props;
        return (
            <Dropdown tag="li" nav inNavbar onMouseOver={this.onMouseEnter} onMouseLeave={this.onMouseLeave} isOpen={this.state.isOpen} toggle={this.toggle}>
                { children }
            </Dropdown>
        );
    }
}